import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState } from "react";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { useCsAttributeById } from "@plansoft-configuration-renderer/framework";
import { useConfigurationAttributeGroupTranslators } from "@plansoft-configuration-renderer/localization";
import { useBuildNavigationFromLayout } from "./useBuildNavigationFromLayout";
/**
 * Displays navigation in configuration as a list
 * - requires {@linkcode AttributeWrapper} to have its `id` property set to the path
 *
 * @see {@link useBuildNavigationFromLayout} for custom implementations
 * @param props
 * @returns
 */
export function ConfigurationNavigation(props) {
    const { showGroups = false, showAllAttributes = false } = props;
    const items = useBuildNavigationFromLayout({
        showGroups,
        showAllAttributes,
    });
    return _jsx(NavigationList, { items: items });
}
function NavigationList(props) {
    return (_jsx(List, { children: _jsx(NavigationListItems, { items: props.items }) }));
}
function NavigationListItems(props) {
    return (_jsx(Fragment, { children: props.items.map((item, itemIndex) => (_jsx(NavigationListItem, Object.assign({}, item), itemIndex))) }));
}
function NavigationListItem(props) {
    if ("attributeId" in props) {
        return _jsx(AttributeNavigationListItem, Object.assign({}, props));
    }
    else {
        return _jsx(GroupNavigationListItem, Object.assign({}, props));
    }
}
function AttributeNavigationListItem(props) {
    var _a, _b;
    const attribute = useCsAttributeById(props.attributeId);
    const text = (_b = (_a = attribute === null || attribute === void 0 ? void 0 : attribute.name) !== null && _a !== void 0 ? _a : attribute === null || attribute === void 0 ? void 0 : attribute.id) !== null && _b !== void 0 ? _b : props.attributeId;
    // requires id property to be set on attribute
    const link = `#${attribute === null || attribute === void 0 ? void 0 : attribute.path}`;
    return (_jsx(ListItemButton, { component: "a", href: link, children: text }));
}
function GroupNavigationListItem(props) {
    const [isOpen, setIsOpen] = useState(false);
    const translateGroup = useConfigurationAttributeGroupTranslators();
    const text = translateGroup.name(props.groupId);
    return (_jsxs(Fragment, { children: [_jsxs(ListItemButton, { onClick: () => setIsOpen(!isOpen), children: [_jsx(ListItemText, { primary: text }), isOpen ? _jsx(ExpandLess, {}) : _jsx(ExpandMore, {})] }), _jsx(Collapse, { in: isOpen, timeout: "auto", unmountOnExit: true, children: _jsx(List, { disablePadding: true, sx: { pl: 2 }, children: _jsx(NavigationListItems, { items: props.items }) }) })] }));
}
//# sourceMappingURL=ConfigurationNavigation.js.map